export default function Loader() {
	return (
		<div className="booking__loader" aria-hidden="true">
			<span />
			<span />
			<span />
		</div>
	);
}
